module.exports = __webpack_public_path__ + "static/media/Q4_figure.30fe57d4.png";